import type { QuoteBlockData } from './quote.types';
import { QuoteBlock } from './Quote.ui';

interface QuoteBlockRendererProps {
  block: QuoteBlockData;
}

export function QuoteRenderer({ block }: QuoteBlockRendererProps) {
  const { backgroundColor, heading, icon, subheading, textAlignment, bynderIcon } = block;
  return (
    <QuoteBlock
      backgroundColor={backgroundColor}
      heading={heading}
      icon={icon}
      bynderIcon={bynderIcon}
      subheading={subheading}
      textAlignment={textAlignment}
    />
  );
}
